import { CabinetFileType } from "@bitwarden/web-vault/app/models/types/cabinet.types";

export type CabinetFileIconMeta = {
  icon: string;
  iconColor: string;
  badgeClass: string;
};

const CABINET_FILE_ICON_META: Record<CabinetFileType, CabinetFileIconMeta> = {
  pdf: {
    icon: "file-type-pdf",
    iconColor: "dt-error-500",
    badgeClass: "tw-bg-dt-error-200",
  },
  jpg: {
    icon: "photo",
    iconColor: "dt-information-500",
    badgeClass: "tw-bg-dt-information-200",
  },
  csv: {
    icon: "file-spreadsheet",
    iconColor: "dt-success-500",
    badgeClass: "tw-bg-dt-success-200",
  },
};

const DEFAULT_ICON_META: CabinetFileIconMeta = CABINET_FILE_ICON_META.pdf;

/**
 * Extension -> cabinet file category. `VaultFileView.mimeType` actually stores the browser's
 * raw `File.type` (e.g. "application/pdf"), not this category, because `CabinetService.getFile()`
 * still needs a real MIME type there to rebuild a previewable File. So the category shown in the
 * UI (icon colour, header counts) is derived from the file name extension instead, which is
 * always accurate to what was uploaded.
 */
const EXTENSION_TO_CABINET_FILE_TYPE: Record<string, CabinetFileType> = {
  pdf: "pdf",
  doc: "pdf",
  docx: "pdf",
  txt: "pdf",
  jpg: "jpg",
  jpeg: "jpg",
  png: "jpg",
  csv: "csv",
  xls: "csv",
  xlsx: "csv",
};

export function resolveCabinetFileType(fileName: string | undefined): CabinetFileType {
  const extension = (fileName?.split(".").pop() ?? "").toLowerCase();
  return EXTENSION_TO_CABINET_FILE_TYPE[extension] ?? "pdf";
}

export function getCabinetFileIconMeta(fileName: string | undefined): CabinetFileIconMeta {
  return CABINET_FILE_ICON_META[resolveCabinetFileType(fileName)] ?? DEFAULT_ICON_META;
}
